import { useMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';

type UpdatePlanRequest = {
  priceId: string,
};

type UpdatePlanResult = {
  sessionUrl?: string | null,
};

function updatePlan(priceId: string): Promise<UpdatePlanResult | undefined> {
  return post<UpdatePlanRequest, UpdatePlanResult>('/api/organizations/subscription', { priceId })
    .then(({ data }) => data);
}

/**
 * Mutation used to update the current plan the organizatio is in.
 */
export function useUpdatePlan() {
  return useMutation({
    mutationFn: (priceId: string) => updatePlan(priceId),
  });
}
